import { useIntl } from 'react-intl';

import { useLocale } from './useLocale';
import { useUrlGenerator } from './useUrlGenerator';

export type CommitmentLink = {
    name: string;
    label: string;
    url: string;
};

type ReturnType = {
    [key: CommitmentLink['name']]: CommitmentLink | null;
};

export function useCommitmentsLinks(): ReturnType {
    const { formatMessage } = useIntl();
    const { generateBrandUrl } = useUrlGenerator();
    const { locale } = useLocale();

    const conceptUrl = generateBrandUrl('concept');
    const concept = conceptUrl
        ? {
              name: 'concept',
              label: formatMessage({ id: 'global.header.globalNav.concept.label' }),
              url: conceptUrl,
          }
        : null;

    const impactUrl = generateBrandUrl('impact');
    const impact = impactUrl
        ? {
              name: 'impact',
              label: formatMessage({ id: 'global.header.globalNav.impact.label' }),
              url: impactUrl,
          }
        : null;

    const bCorpUrl = generateBrandUrl('b_corp');
    const bCorp = bCorpUrl
        ? {
              name: 'b-corp',
              label: formatMessage({ id: 'global.header.globalNav.bCorp.label' }),
              url: bCorpUrl,
          }
        : null;

    const impactReport = {
        name: 'impact-report',
        label: formatMessage({ id: 'global.header.globalNav.impactReport.label' }),
        url:
            locale === 'fr-FR'
                ? 'https://issuu.com/evaneos/docs/evaneos_impact_report_2024_fr_?fr=xKAE9_zU1NQ'
                : 'https://issuu.com/evaneos/docs/evaneos-impact-report-12_en_us_2023.09_20_1_?fr=xKAE9_zU1NQ ',
    };

    const agenciesUrl = generateBrandUrl('agency_page');
    const agencies = agenciesUrl
        ? {
              name: 'agencies',
              label: formatMessage({ id: 'global.header.globalNav.agencies.label' }),
              url: agenciesUrl,
          }
        : null;

    const ourCommitmentsUrl = generateBrandUrl('our_commitments');
    const ourCommitments = ourCommitmentsUrl
        ? {
              name: 'our-commitments',
              label: formatMessage({ id: 'global.header.globalNav.ourCommitments.label' }),
              url: ourCommitmentsUrl,
          }
        : null;

    return {
        concept,
        impact,
        bCorp,
        impactReport,
        agencies,
        ourCommitments,
    };
}
